<template>
    <div class="pages couponDetails">
        <div class="f1">
            <div class="d1">
                <p class="title">
                    <img src="../../assets/images/newIcon/margetmiddledetails_coupons_icon2.png" alt="">
                    优惠券详细信息
                </p>
                <p>
                    <span>
                        <i>*</i>
                        优惠券名称：
                    </span> 
                    国庆特惠优惠券
                </p>
                <p>
                    <span>
                        名称备注：
                    </span> 
                    沉睡用户促活适用
                </p>
                <p>
                    <span>
                        <i>*</i>
                        发放总量：
                    </span> 
                    100000张
                </p>
                <p>
                    <span>
                        创建时间：
                    </span> 
                    2021.10.10 18:00:00
                </p>
            </div>
            <div class="d2">
                 <p class="title">
                    <img src="../../assets/images/newIcon/margetmiddledetails_guize_icon.png" alt="">
                    优惠券规则信息
                </p>
                 <p>
                    <span>
                        类型：
                    </span> 
                    满减券/折扣券/代金券
                </p>
                 <p>
                    <span>
                        内容：
                    </span> 
                    满100元减10元/满100元打9折/抵扣5元
                </p>
                <p>
                    <span>
                        <i>*</i>
                        发放渠道：
                    </span> 
                    健康洪梅
                </p>
                 <p>
                    <span>
                        发放方式：
                    </span> 
                    活跃发放/用户领取/等级发放
                </p>
            </div>
        </div>
        <div>
            <el-card shadow="never" class="chard-box">
                <!-- 顶部区域 -->
                <div class="t1">
                <img
                    src="../../assets/images/newIcon/margetmiddledetails_mx_icon.png"
                    alt=""
                />
                <span></span>优惠券使用明细
                </div>
                <span class="text">2021-06-28 - 2021-07-28 | 过去30天-昨日</span>
                <!-- 数字日期区域 -->
                <div class="numDate mb-30">
                <p class="date" style="font-siez:14px;">7-27（二）</p>
                <div class="num">
                    <div class="">
                        <span class="buleBar"></span><span style="font-siez:14px;">领取人数</span>
                        <p class="blueColor fz43" >13,121<span class="fz12" style="font-weight:400;">人</span></p>
                    </div>
                    <div class="">
                        <span class="greBar"></span><span style="font-siez:14px;">使用人数</span>
                        <p class="blueColor fz43" >13,121<span class="fz12" style="font-weight:400;">人</span></p>
                    </div>
                    <div class="">
                    <span class="redBar"></span><span style="font-siez:14px;">消费订单总额</span>
                    <p class="blueColor fz43" >13,121<span class="fz12" style="font-weight:400;">元</span></p>
                    </div>
                </div>
                </div>
                <div id="trend"></div>
                <!-- <div id="a4" style="margin-top:-20px;"></div> -->
            </el-card>
        </div>
        <div class="f3">
            <div class="d1">
                <div class="t1">
                <img
                    src="../../assets/images/newIcon/accessanalysis_time_icon.png"
                    alt=""
                />
                <span></span>不同用户群组的优惠券使用次数
                </div>
                <span class="text ">2021-06-28 - 2021-07-28 | 过去30天-昨日</span>
                <div id="coupon1"></div>
            </div>
            <div class="d2">
                 <div class="t1">
                <img
                    src="../../assets/images/newIcon/accessanalysis_time_icon.png"
                    alt=""
                />
                <span></span>不同等级的优惠券使用次数
                </div>
                <span class="text">2021-06-28 - 2021-07-28 | 过去30天-昨日</span>
                <div id="coupon2"></div>
            </div>
        </div>
        <div class="f3">
            <div class="d1">
                <div class="t1">
                <img
                    src="../../assets/images/newIcon/accessanalysis_ranklist_icon.png"
                    alt=""
                />
                <span></span>商品使用优惠券排行
                </div>
                <span class="text ">2021-06-28 - 2021-07-28 | 过去30天-昨日</span>
                <div id="coupon3"></div>
            </div>
            <div class="d2">
                 <div class="t1">
                <img
                    src="../../assets/images/newIcon/accessanalysis_ranklist_icon.png"
                    alt=""
                />
                <span></span>品牌使用优惠券排行
                </div>
                <span class="text">2021-06-28 - 2021-07-28 | 过去30天-昨日</span>
                <div id="coupon4"></div>
            </div>
        </div>
    </div>  
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    mounted(){
        this.init();
        this.init2();
        this.init3();
        this.init4();
        this.init5();
    },
    methods:{
        init(){
            let d1=[
                {data:"6.28",name:'领取人数',val:300},
                {data:"6.30",name:'领取人数',val:200},
                {data:"7.2",name:'领取人数',val:300},
                {data:"7.4",name:'领取人数',val:400},
                {data:"7.6",name:'领取人数',val:500},
                {data:"7.8",name:'领取人数',val:100},
                {data:"7.10",name:'领取人数',val:400},
                {data:"7.12",name:'领取人数',val:500},
                {data:"7.14",name:'领取人数',val:200},
                {data:"7.16",name:'领取人数',val:300},
                {data:"7.18",name:'领取人数',val:400},
                {data:"7.20",name:'领取人数',val:300},
                {data:"7.22",name:'领取人数',val:200},
                {data:"7.24",name:'领取人数',val:200},
                {data:"7.26",name:'领取人数',val:200},
            ]
            let d2=[
                {data:"6.28",name:'使用人数',val:100},
                {data:"6.30",name:'使用人数',val:200},
                {data:"7.2",name:'使用人数',val:200},
                {data:"7.4",name:'使用人数',val:300},
                {data:"7.6",name:'使用人数',val:100},
                {data:"7.8",name:'使用人数',val:300},
                {data:"7.10",name:'使用人数',val:400},
                {data:"7.12",name:'使用人数',val:200},
                {data:"7.14",name:'使用人数',val:300},
                {data:"7.16",name:'使用人数',val:400},
                {data:"7.18",name:'使用人数',val:500},
                {data:"7.20",name:'使用人数',val:100},
                {data:"7.22",name:'使用人数',val:200},
                {data:"7.24",name:'使用人数',val:300},
                {data:"7.26",name:'使用人数',val:200},
            ]
            let d3=[
                {data:"6.28",name:'消费订单总额',val:100},
                {data:"6.30",name:'消费订单总额',val:300},
                {data:"7.2",name:'消费订单总额',val:400},
                {data:"7.4",name:'消费订单总额',val:500},
                {data:"7.6",name:'消费订单总额',val:300},
                {data:"7.8",name:'消费订单总额',val:200},
                {data:"7.10",name:'消费订单总额',val:100},
                {data:"7.12",name:'消费订单总额',val:300},
                {data:"7.14",name:'消费订单总额',val:200},
                {data:"7.16",name:'消费订单总额',val:100},
                {data:"7.18",name:'消费订单总额',val:200},
                {data:"7.20",name:'消费订单总额',val:300},
                {data:"7.22",name:'消费订单总额',val:400},
                {data:"7.24",name:'消费订单总额',val:500},
                {data:"7.26",name:'消费订单总额',val:200},
            ]
            let data=[...d1,...d2,...d3];

            const chart = new this.$chart({
            container: 'trend',
            autoFit: true,
            height: 300,
            padding:[30,60,80,60]
            });
            // chart
            // .interval({
            //     theme: {
            //     defaultColor: 'red',
            //     },
            // })
            // .position(0);
            chart.data(data);
            chart.scale({
            month: {
                range: [0, 1],
            },
            temperature: {
                nice: true,
            },
            });
            chart.scale("val", {
                min: 0,
                // max: 1000,
            });
            chart.tooltip({
            showCrosshairs: true,
            shared: true,
            });

            chart.axis('val', {
            label: {
                formatter: (val) => {
                return val;
                },
            },
            });

            chart
            .line()
            .position('data*val')
            .color('name',["#5B8FF9","#5AD8A6","#FF9D4D"])
            .shape('smooth');

            // chart
            // .point()
            // .position('data*val')
            // .color('name')
            // .shape('circle');

            chart.render();
        },
        init2() {
            const data = [
                { type: "低消费群体", value: 300 },
                { type: "高消费群体", value: 85 },
                { type: "老带新用户", value: 103 },
                { type: "老客户", value: 142 },
                { type: "沉睡用户", value: 400 }
            ];
            const chart =new this.$chart({
                container: "coupon1",
                autoFit: true,
                height: 350,
            });
            chart.data(data);
            chart.scale({
                value: {
                max: 500,
                min: 0,
                alias: "优惠券使用次数",
                },
            });
            //
            // chart.axis(true);
            // chart.axis("type", {
            //     title: null,
            //     tickLine: null,
            //     line: null,
            // });

            // chart.axis("value", {
            //     label: null,
            //     title: {},
            // });
             // 显示Y轴的竖线
            chart.axis("value", {
                line: {
                style: {
                    lineWidth: 1,
                    stroke: "#BFBFBF",
                },
                },
            });
              // 自定义图例
            chart.legend({
                custom: true,
                items: [
                {
                    name: "优惠券使用次数",
                    id: "type",
                    marker: { symbol: "square", style: { r: 4, fill: "#6395f9" } },
                },
                ],
            });
            // chart.legend(false);
            chart.coordinate().transpose();
            chart
                .interval()
                .position("type*value")
                .size(26)
                .label("value", {
                style: {
                    fill: "#8d8d8d",
                },
                offset: 10,
                });
            chart.interaction("element-active");
            chart.render();
        },
        init3() {
            
              const data = [
                { type: "江小白", value: 200 },
                { type: "百威啤酒", value: 300 },
                { type: "乌苏啤酒", value: 443 },
                { type: "五粮液", value: 542 },
                { type: "飞天茅台", value: 800 }
            ];
            const chart =new this.$chart({
                container: "coupon3",
                autoFit: true,
                height: 350,
            });
            chart.data(data);
            chart.scale({
                value: {
                max: 1000,
                min: 0,
                alias: "优惠券使用次数",
                },
            });
            //
            // chart.axis(true);
            // chart.axis("type", {
            //     title: null,
            //     tickLine: null,
            //     line: null,
            // });

            // chart.axis("value", {
            //     label: null,
            //     title: {},
            // });
             // 显示Y轴的竖线
            chart.axis("value", {
                line: {
                style: {
                    lineWidth: 1,
                    stroke: "#BFBFBF",
                },
                },
            });
              // 自定义图例
            chart.legend({
                custom: true,
                items: [
                {
                    name: "优惠券使用次数",
                    id: "type",
                    marker: { symbol: "square", style: { r: 4, fill: "#6395f9" } },
                },
                ],
            });
            // chart.legend(false);
            chart.coordinate().transpose();
            chart
                .interval()
                .position("type*value")
                .size(26)
                .label("value", {
                style: {
                    fill: "#8d8d8d",
                },
                offset: 10,
                });
            chart.interaction("element-active");
            chart.render();
        },
        init4() {
            
              const data = [
                { type: "香槟", value: 200 },
                { type: "啤酒", value: 300 },
                { type: "洋酒", value: 443 },
                { type: "红酒", value: 542 },
                { type: "白酒", value: 800 }
            ];
            const chart =new this.$chart({
                container: "coupon4",
                autoFit: true,
                height: 350,
            });
            chart.data(data);
            chart.scale({
                value: {
                max: 1000,
                min: 0,
                alias: "优惠券使用次数",
                },
            });
            //
            // chart.axis(true);
            // chart.axis("type", {
            //     title: null,
            //     tickLine: null,
            //     line: null,
            // });

            // chart.axis("value", {
            //     label: null,
            //     title: {},
            // });
             // 显示Y轴的竖线
            chart.axis("value", {
                line: {
                style: {
                    lineWidth: 1,
                    stroke: "#BFBFBF",
                },
                },
            });
              // 自定义图例
            chart.legend({
                custom: true,
                items: [
                {
                    name: "优惠券使用次数",
                    id: "type",
                    marker: { symbol: "square", style: { r: 4, fill: "#6395f9" } },
                },
                ],
            });
            // chart.legend(false);
            chart.coordinate().transpose();
            chart
                .interval()
                .position("type*value")
                .size(26)
                .label("value", {
                style: {
                    fill: "#8d8d8d",
                },
                offset: 10,
                });
            chart.interaction("element-active");
            chart.render();
        },
        init5() {
            
              const data = [
                { type: "钻石会员", value: 200 },
                { type: "青铜会员", value: 300 },
                { type: "白金会员", value: 443 },
                { type: "黄金会员", value: 542 },
                { type: "白银会员", value: 800 }
            ];
            const chart =new this.$chart({
                container: "coupon2",
                autoFit: true,
                height: 350,
            });
            chart.data(data);
            chart.scale({
                value: {
                max: 1000,
                min: 0,
                alias: "优惠券使用次数",
                },
            });
            chart.axis('type', {
                tickLine: null,
                line: null,
            });
             // 显示Y轴的竖线
            chart.axis("value", {
                line:false,
                label: null,
                grid: null,
            });
              // 自定义图例
            chart.legend({
                custom: false,
                items: [
                {
                    name: "",
                    id: "type",
                    marker: { symbol: "square", style: { r: 4, fill: "#fff" } },
                },
                ],
            });
            // chart.legend(false);
            chart.coordinate().transpose();
            chart
                .interval()
                .position("type*value")
                .color('type',["#32C5FF","#E791FF","#CECECE","#FFC116","#44D7B6"])
                .size(26)
                .label("value", {
                style: {
                    fill: "#8d8d8d",
                },
                offset: 10,
                });
            chart.interaction("element-active");
            chart.render();
        },
    }
}
</script>
<style lang="less" scoped>
    .couponDetails{
        .f1{
            padding:30px;
            display: flex;
            background: #fff;
            div{
               box-sizing: border-box;
                &:first-of-type{
                     width:45%;
                    border-right:1px solid #E6E6E6;
                }
                &:last-of-type{
                    width:55%;
                    padding-left:10%;
                }
            }
            p{
                margin-bottom:15px;
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                span{
                    i{
                        color:#E02020;
                    }
                    margin-right:30px;
                    text-align: right;
                    display: inline-block;
                    width:100px;
                    color: #666666;
                }
            }
            .title{
                margin-bottom:30px;
                 font-size: 16px;
                    font-weight: 500;
                    color: #333333;
                img{
                    width:20px;
                    height:20px;
                    vertical-align: bottom;
                }
            }
           
        }
        .f3{
            margin-top:30px;
            display: flex;
            justify-content: space-between;
            div{
              
                box-sizing: border-box;
                
                background:#fff;
            }
            .d1,.d2{
                width:49%;
                  padding:30px 30px;
            }
            .t1{
                margin-bottom:15px;
                img{
                    width:20px;
                }
            }
            .text{
                display: block;
                margin-bottom:30px;
                font-size: 12px;
                font-weight: 400;
            }
        }
        .buleBar,
        .t1{
            img{
                margin-right: 10px;
                width:20px;
                vertical-align: bottom;
            }
            font-size: 16px;
            font-weight: 500;
            color: #333940;
        }
    .buleBar{
        display: inline-block;
        width: 4px;
        height: 13px;
        background-color: #327eff;
        border-radius: 2px;
        margin-right: 10px;
    }
    .redBar{
        display: inline-block;
        width: 4px;
        height: 13px;
        background-color: #FF9D4D;
        border-radius: 2px;
        margin-right: 10px;
    }
    .greBar {
        display: inline-block;
        width: 4px;
        height: 13px;
        background-color: #327eff;
        border-radius: 2px;
        margin-right: 10px;
    }
    .greBar {
        background-color: #73deb3;
    }
    .blueColor {
            color: #327eff;
    }
        .chard-box {
      margin-top: 20px;
    //   width: 49%;
    //   height: 480px;
      // 顶部文字样式
      .fl {
        font-size: 16px;
        display: flex;
        align-items: center;
        b {
          margin-left: 10px;
        }
        img {
          width: 24px;
        }
      }
      .text {
        display: block;
        // margin-left: 12px;
        color: #333;
        font-size: 12px;
        line-height: 24px;
        margin-top: 10px;
      }
      //数字样式
      .mian {
        display: flex;
        justify-content: space-between;
        .lnum {
          display: flex;
          .m2 {
            margin-left: 20px;
            margin-bottom: -5px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            color: #0091ff;
          }
          .m3 {
            margin-left: 20px;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
          }
        }
        .rnum {
          margin-right: 60px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          &:after {
            content: "";
            width: 2px;
            height: 40px;
            background-color: #333;
            position: absolute;
            top: 16px;
            left: -20px;
          }
        }
      }
      // 图4单独样式部分
      .numDate {
        margin-top: 10px;
        // margin-left: 13px;
        .date {
          color: #327eff;
        }
        .num {
            margin-top:10px;
          display: flex;
        //   justify-content: space-between;
            div{
                margin-right:80px;
                span{
                    font-size:14px;
                    font-weight: 400;
                    color: #333333;
                }
                p{
                    margin-top:10px;
                    padding-left:15px;
                    font-size: 36px;
                    font-weight: bold;
                    color: #327EFF;
                    span{
                        font-size: 14px;
                        font-weight: 500;
                        color: #327EFF;
                    }
                }
            }
          .right {
            margin-right: 60px;
          }

        }
      }
      //图5单独样式部分
      .top {
        .fl {
          font-size: 16px;
          display: flex;
          float: left;
          b {
            margin-left: 6px;
          }
          img {
            width: 24px;
          }
          .text {
            // margin-left: 12px;
            color: #333;
            font-size: 12px;
            line-height: 24px;
          }
        }
        .fr {
          float: right;
        }
      }
      //图6单独样式部分
      .top6 {
        margin-top: -5px;
        .fl {
          float: left;
          font-size: 16px;
          display: flex;
          b {
            margin-left: 6px;
          }
          img {
            width: 24px;
          }
          .text {
            margin-left: 12px;
            color: #333;
            font-size: 12px;
            line-height: 24px;
          }
        }
        .fr {
          float: right;
          color: #999999;
          font-size: 12px;
          p {
            img {
              width: 16px;
              vertical-align: middle;
              //   margin-right: 10px;
            }
          }
          .my-select {
            margin-left: 10px;
          }
        }
      }
        }
    }
</style>